module.exports = __webpack_public_path__ + "img/comm-04-press-img-01.2254946c.jpg";